import React from 'react'
import styled from 'styled-components'
import TableColumnLabel from '../ui/table-column-label'
import IconParticipants from '../../images/icon-square-participants.svg'
import IconInvited from '../../images/icon-square-invited.svg'
import IconEngagementRatio from '../../images/icon-square-engagement-ratio.svg'
import ResultUpIcon from '../../images/icon-arrow-up-green.svg'
import ResultDownIcon from '../../images/icon-arrow-down-red.svg'
import NoProgressIcon from '../../images/icon-no-progress.svg'

const EngagementStats = ({current, previous, useTranslate}) => {
  const participantsProgress = current.answeredRespondentCount - previous.answeredRespondentCount;
  const invitedProgress = current.invitedRespondentCount - previous.invitedRespondentCount;
  const engagementRatioProgress = current.engagementPercentage - previous.engagementPercentage;

  const getResultIcon = (result) => {
    return result < 0 ? ResultDownIcon : result === 0 ? NoProgressIcon : ResultUpIcon;
  }

  return (
    <div>
      <EngagementStatsColumns style={{padding: "0"}} className={"text-center labels"}>
        <span></span>
        <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
        <TableColumnLabel>{useTranslate("progress_reports.label_latest")}</TableColumnLabel>
        <TableColumnLabel>{useTranslate("progress_reports.label_previous")}</TableColumnLabel>
      </EngagementStatsColumns>
      <EngagementStatsColumns className={"results"}>
        <EngagementStatTitle>
          <img src={IconParticipants} alt="icon"/>
          <span className="title">{useTranslate("dashboard.participants")}</span>
        </EngagementStatTitle>
        <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
        <span className="progress-result">
          <img src={getResultIcon(participantsProgress)} alt="icon" />
          {participantsProgress > 0 ? `+${participantsProgress}` : participantsProgress}
        </span>
        <TableColumnLabel>{useTranslate("progress_reports.label_latest")}</TableColumnLabel>
        <span className="result-latest">{current.answeredRespondentCount}</span>
        <TableColumnLabel>{useTranslate("progress_reports.label_previous")}</TableColumnLabel>
        <span className="result-previous">{previous.answeredRespondentCount}</span>
      </EngagementStatsColumns>
      <EngagementStatsColumns style={{borderTop: "1px solid #D7D7D7"}}  className={"results"}>
        <EngagementStatTitle>
          <img src={IconInvited} alt="icon"/>
          <span className="title">{useTranslate("dashboard.invited")}</span>
        </EngagementStatTitle>
        <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
        <span className="progress-result">
          <img src={getResultIcon(invitedProgress)} alt="icon" />
          {invitedProgress > 0 ? `+${invitedProgress}` : invitedProgress}
        </span>
        <TableColumnLabel>{useTranslate("progress_reports.label_latest")}</TableColumnLabel>
        <span className="result-latest">{current.invitedRespondentCount}</span>
        <TableColumnLabel>{useTranslate("progress_reports.label_previous")}</TableColumnLabel>
        <span className="result-previous">{previous.invitedRespondentCount}</span>
      </EngagementStatsColumns>
      <EngagementStatsColumns style={{borderTop: "1px solid #D7D7D7"}}  className={"results"}>
        <EngagementStatTitle>
          <img src={IconEngagementRatio} alt="icon"/>
          <span className="title">{useTranslate("dashboard.engagement_ratio")}</span>
        </EngagementStatTitle>
        <TableColumnLabel>{useTranslate("progress_reports.label_progress")}</TableColumnLabel>
        <span className="progress-result">
          <img src={getResultIcon(engagementRatioProgress)} alt="icon" />
          {engagementRatioProgress > 0 ? `+${engagementRatioProgress.toFixed(1)}` : engagementRatioProgress.toFixed(1)}%
        </span>
        <TableColumnLabel>{useTranslate("progress_reports.label_latest")}</TableColumnLabel>
        <span className="result-latest">{current.engagementPercentage.toFixed(0)}%</span>
        <TableColumnLabel>{useTranslate("progress_reports.label_previous")}</TableColumnLabel>
        <span className="result-previous">{previous.engagementPercentage.toFixed(0)}%</span>
      </EngagementStatsColumns>
    </div>
  )
}

export default EngagementStats;

const EngagementStatsColumns = styled.div`

  padding: 10px 0;
  font-weight: 500;
  
  > span:not(.table-column-label) {
    display: block;
    margin-bottom: 5px;
  }
  
  .progress-result {
    display: flex;
    align-items: center;
    font-size: 1.25rem;
    
    img {
      width: 17px;
      height: auto;
      margin-right: 5px;
    }
  }
  
  .result-previous {
    color: #5F7D95;
  }
  
  &.labels {
    display: none;
  }
  
  @media (min-width: 600px) {
    display: grid;
    grid-template-columns: 4fr 2fr 2fr 2fr;
    grid-column-gap: 10px;
    align-items: center;
    padding: 15px 0;
    
    &.labels {
      display: grid;
    }
      
    &.results .table-column-label {
      display: none;
    }
    
    > span:not(.table-column-label) {
      display: flex;
      margin-bottom: 0;
      justify-content: center;
    }
    
    .progress-result {
      font-size: 1.5rem;
    }
    
    .result-latest, .result-previous {
      font-size: 1.125rem;
    }
  }
`;

const EngagementStatTitle = styled.div`
  display: flex;
  align-items: center;
  font-weight: 500;
  line-height: 1.2;
  margin-bottom: 10px;
  
  img {
    width: 30px;
    height: auto;
    margin-right: 10px;
  }
  
  @media (min-width: 600px) {
    font-size: 20px;
    margin-bottom: 0;
    
    img {
      width: 50px;
    }
  }

`;


// WEBPACK FOOTER //
// ./src/components/progress-reports/engagement-stats.js